var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"ficenca-app"},[_c('Toolbar'),_c('v-main',{staticClass:"ficenca-main"},[_c('transition',{attrs:{"name":"ficenca-view","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }